import { render, staticRenderFns } from "./three-risk.vue?vue&type=template&id=0f8832fe&scoped=true"
import script from "./three-risk.vue?vue&type=script&lang=js"
export * from "./three-risk.vue?vue&type=script&lang=js"
import style0 from "./three-risk.vue?vue&type=style&index=0&id=0f8832fe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.6.11_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8832fe",
  null
  
)

export default component.exports